import { registerAction, dragAction, pinchAction, wheelAction, scrollAction, moveAction, hoverAction } from '@use-gesture/core/actions';
export * from '@use-gesture/core/actions';
import { Controller, parseMergedHandlers } from '@use-gesture/core';
export * from '@use-gesture/core/utils';
export * from '@use-gesture/core/types';

function _toPrimitive(input, hint) {
  if (typeof input !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}

function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}

function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}

class Recognizer {
  constructor(target, handlers, config, gestureKey, nativeHandlers) {
    this._target = target;
    this._gestureKey = gestureKey;
    this._ctrl = new Controller(handlers);
    this._ctrl.applyHandlers(handlers, nativeHandlers);
    this._ctrl.applyConfig(_objectSpread2(_objectSpread2({}, config), {}, {
      target
    }), gestureKey);
    this._ctrl.effect();
  }
  destroy() {
    this._ctrl.clean();
  }
  setConfig(config) {
    this._ctrl.clean();
    this._ctrl.applyConfig(_objectSpread2(_objectSpread2({}, config), {}, {
      target: this._target
    }), this._gestureKey);
    this._ctrl.effect();
  }
}

const DragGesture = function DragGesture(target, handler, config) {
  registerAction(dragAction);
  return new Recognizer(target, {
    drag: handler
  }, config || {}, 'drag');
};

const PinchGesture = function PinchGesture(target, handler, config) {
  registerAction(pinchAction);
  return new Recognizer(target, {
    pinch: handler
  }, config || {}, 'pinch');
};

const WheelGesture = function WheelGesture(target, handler, config) {
  registerAction(wheelAction);
  return new Recognizer(target, {
    wheel: handler
  }, config || {}, 'wheel');
};

const ScrollGesture = function ScrollGesture(target, handler, config) {
  registerAction(scrollAction);
  return new Recognizer(target, {
    scroll: handler
  }, config || {}, 'scroll');
};

const MoveGesture = function MoveGesture(target, handler, config) {
  registerAction(moveAction);
  return new Recognizer(target, {
    move: handler
  }, config || {}, 'move');
};

const HoverGesture = function HoverGesture(target, handler, config) {
  registerAction(hoverAction);
  return new Recognizer(target, {
    hover: handler
  }, config || {}, 'hover');
};

function createGesture(actions) {
  actions.forEach(registerAction);
  return function (target, _handlers, _config) {
    const {
      handlers,
      nativeHandlers,
      config
    } = parseMergedHandlers(_handlers, _config || {});
    return new Recognizer(target, handlers, config, undefined, nativeHandlers);
  };
}

const Gesture = function Gesture(target, handlers, config) {
  const gestureFunction = createGesture([dragAction, pinchAction, scrollAction, wheelAction, moveAction, hoverAction]);
  return gestureFunction(target, handlers, config || {});
};

export { DragGesture, Gesture, HoverGesture, MoveGesture, PinchGesture, ScrollGesture, WheelGesture, createGesture };
